import { Validator } from '@vista-digital/validator';
import { FilmThumbnailMediaType } from '../../film/thumbnail/types/media-type';
import { defaultFilmTrailerConfig, filmTrailerConfigValidatorSchema } from '../../film/trailer/types/config';
export const defaultMemberFilmWatchlistConfig = {
    filmMediaType: FilmThumbnailMediaType.Poster,
    playTrailerButton: Object.assign(Object.assign({}, defaultFilmTrailerConfig), { show: true }),
    emptyListButton: {
        show: true
    }
};
export const memberFilmWatchlistConfigValidator = Validator.object({
    filmMediaType: Validator.oneOf(Object.values(FilmThumbnailMediaType)),
    filmUrlFactory: Validator.optional(Validator.fn()),
    playTrailerButton: Validator.object(Object.assign(Object.assign({}, filmTrailerConfigValidatorSchema), { show: Validator.boolean() })),
    emptyListButton: Validator.object({ show: Validator.boolean() })
});
